import { option } from 'fp-ts';
import { SecondaryDestructiveButton } from 'ui/button';
import { useCatalogContext } from 'modules/catalog/catalogSelector';
import { useCatalogSelectionContext } from './contexts/CatalogSelectionContext';
import { useCatalogPreviewContext } from './contexts/CatalogPreviewContext';
import { useTranslation } from '../hooks';

export const ResetButton = () => {
  const { t } = useTranslation();
  const { change, changeFieldDetails } = useCatalogContext();
  const { isEnabled, update } = useCatalogSelectionContext();
  const { closePreview } = useCatalogPreviewContext();

  const onReset = () => {
    change(option.none);
    changeFieldDetails(option.none);
    update(false);
    closePreview();
  };

  if (!isEnabled) return null;

  return (
    <SecondaryDestructiveButton onClick={onReset}>
      {t('catalogQuery.reset')}
    </SecondaryDestructiveButton>
  );
};
